import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formatViews = (num: number): string => {
    if (num >= 10000) {
      return `${(num / 10000).toFixed(1)}万`;
    }
    return num.toString();
  };

  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] overflow-hidden"
    >
      <div className="relative overflow-hidden">
        <img
          src={video.coverImage}
          alt={video.title}
          title={video.title}
          className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-900/80 text-background-50 text-xs px-2 py-0.5 rounded-md backdrop-blur-sm">
          {video.duration}
        </div>
        <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md">
          {video.rating.toFixed(1)}
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
          {video.description}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            <span>{formatViews(video.views)}</span>
          </div>
          <span>{video.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}